import baustein from "baustein";
import history from "web/script/utils/history";
import _ from "underscore";
import browser from "web/script/utils/browser";

var COVER_LOADING_CLASS = "featured-collection-module__cover-image--loading";

export default baustein.register("featured-collection", {
    setupEvents: function(add) {
        add("openOverlay", "product-card", this._onOpenProductOverlay);
    },

    onInsert: function() {
        this._setScrollContainerWidth();
        this.setupImageLoading();
        this.setGlobalHandler("resize", this._setScrollContainerWidth);
    },

    onRemove: function() {
        this.releaseGlobalHandler("resize", this._setScrollContainerWidth);
    },

    _onOpenProductOverlay: function(event) {
        history.pushState(event.url, event.queryParams);
    },

    /**
     * Sets the width of the scrollable area wrapper to the
     * total width of it's children to get proper overflow.
     */
    _setScrollContainerWidth: _.throttle(function() {
        if (browser.getViewport() > browser.VIEWPORTS.TABLET) {
            return;
        }
        var featuredCollectionProducts = this.el.querySelectorAll(
            ".featured-collection-module__product"
        );
        var scrollWrapperWidth = 0;

        _.each(featuredCollectionProducts, function(el) {
            var elStyle = getComputedStyle(el, null);

            scrollWrapperWidth += parseInt(elStyle.width, 10);
            scrollWrapperWidth += parseInt(elStyle.marginLeft, 10);
            scrollWrapperWidth += parseInt(elStyle.marginRight, 10);
        });
        this.el.querySelector(".featured-collection-module__scroll-wrapper").style.width =
            scrollWrapperWidth + "px";
    }, 200),

    /**
     * We only want a cover image on desktop. Image loaded callback. Removes the loading class and
     * makes the image fade in (via CSS opacity transitions).
     */
    _onCoverImageLoaded: function() {
        var coverImage = this.el.querySelector(".featured-collection-module__cover-image");
        coverImage.style.backgroundImage = "url('" + this.options.coverImage + "')";
        coverImage.classList.remove(COVER_LOADING_CLASS);
    },

    /**
     * Sets up the image loaded callback to make the cover
     * image fade-in smoothly.
     */
    setupImageLoading: function() {
        if (browser.getViewport() < browser.VIEWPORTS.TABLET) {
            return;
        }
        var image = new Image();
        image.src = this.options.coverImage;
        image.onload = this._onCoverImageLoaded.bind(this);
    },
});
